import { render, staticRenderFns } from "./RedirectFromFacebook.vue?vue&type=template&id=070cae7c&"
import script from "./RedirectFromFacebook.vue?vue&type=script&lang=js&"
export * from "./RedirectFromFacebook.vue?vue&type=script&lang=js&"
import style0 from "./RedirectFromFacebook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports